import { render, staticRenderFns } from "./RespondentWait.vue?vue&type=template&id=143f9d26"
import script from "./RespondentWait.vue?vue&type=script&lang=js"
export * from "./RespondentWait.vue?vue&type=script&lang=js"
import style0 from "./RespondentWait.vue?vue&type=style&index=0&id=143f9d26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports